module.exports = __webpack_public_path__ + "static/sms-marketing-35fe0de24803b7e99ccc66dc62b26b54.webp";